// Copyright (c) 2022 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getClosingAccount} from '../../shared/repositories';
import {getDefaultState as getDealerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/dealer';

export const readClosingAccount = selectedAccounts =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const closingAccountChanges = await getClosingAccount(selectedAccounts);

            const overrideAccount = getDealerDefaultState();
            const accountLookup = '';

            if (closingAccountChanges.length > 0) {

                const closingAccountAPIResponse = closingAccountChanges.map(closingAccount => ({
                    ...closingAccount, accountLookup, overrideAccount
                }));

                dispatch({
                    data: closingAccountAPIResponse,
                    type: actions.UPDATE_TCSM_CLOSING_ACCOUNT
                });

            } else {

                dispatch({
                    data: closingAccountChanges,
                    type: actions.UPDATE_TCSM_CLOSING_ACCOUNT
                });

            }

            dispatch({
                length: closingAccountChanges.length,
                type: actions.UPDATE_TCSM_CLOSING_ACCOUNT_LENGTH
            });

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/get-close-account.js